import styled from 'styled-components';
import { InputStyles } from './Input';

const Select = styled.select`
  ${InputStyles}
`;

export default Select;
